import { RequestsAction } from '.';
import {
  deleteApiCallStatus,
  IApiCallStatus,
  IRequest,
  ISaveRequestOutput,
} from '../common';
import {
  compose,
  map as lmap,
  find as lfind,
  isEmpty as lisEmpty,
  filter as lfilter,
} from 'lodash/fp';
import { assocPath, pathOr, equals, not } from 'rambda';
import { flow } from 'fp-ts/function';

export interface IRequestsState {
  requests: ISaveRequestOutput[];
  apiCallStatus: IRequestsApiCallStatus[];
  selectedRequests: ISaveRequestOutput[];
}

export const initRequestsState: IRequestsState = {
  requests: [],

  apiCallStatus: [],

  selectedRequests: [],
};

export interface IRequestsApiCallStatus {
  type: 'GetRequests';
  apiCallStatus: IApiCallStatus;
}

export const requestsReducer = (
  state: IRequestsState,
  { type, payload }: RequestsAction
): IRequestsState => {
  switch (type) {
    case 'GetRequests':
      return {
        ...state,
        apiCallStatus: [
          ...deleteApiCallStatus({ type: 'GetRequests' })(state.apiCallStatus),
          { type: 'GetRequests', apiCallStatus: null },
        ],
      };

    case 'GetRequestsSuccess':
      return {
        ...state,
        apiCallStatus: [
          ...deleteApiCallStatus({ type: 'GetRequests' })(state.apiCallStatus),
          { type: 'GetRequests', apiCallStatus: true },
        ],
        requests: lmap<IRequest, ISaveRequestOutput>(
          compose(assocPath('msgCode', null), assocPath('msgText', null))
        )(payload as IRequest[]),
      };

    case 'GetRequestsError':
      return {
        ...state,
        apiCallStatus: [
          ...deleteApiCallStatus({ type: 'GetRequests' })(state.apiCallStatus),
          { type: 'GetRequests', apiCallStatus: false },
        ],
      };

    case 'ToggleRequestSelection':
      // TODO how to remove as
      const request = payload as ISaveRequestOutput;
      return {
        ...state,
        selectedRequests: flow(
          lfind<ISaveRequestOutput>({ requestId: request.requestId }),
          lisEmpty
        )(state.selectedRequests)
          ? [request, ...state.selectedRequests]
          : lfilter<ISaveRequestOutput>(
              flow(
                pathOr<number>(0, 'requestId'),
                equals(request.requestId),
                not
              )
            )(state.selectedRequests),
      };

    case 'ClearRequestSelection':
      return { ...state, selectedRequests: [] };
  }
};
